// **  Initial State
const initialState = {
    information:{
        url:'productsInformation',
        addUrl:'productInformationCreate',
        updateUrl:'productInformationUpdate',
        deleteUrl:'productInformationDelete',
        loading:true,
        items: [],
        errors:[],
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    story:{
        url:'stories',
        addUrl:'storyCreate',
        updateUrl:'storyUpdate',
        deleteUrl:'storyDelete',
        loading:true,
        items: [],
        errors:[],
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    sustainability:{
        url:'productRoute',
        addUrl:'sustainabilityCreate',
        updateUrl:'sustainabilityUpdate',
        deleteUrl:'sustainabilityDelete',
        loading:true,
        items: [],
        errors:[],
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    certifications:{
        url:'certificates',
        addUrl:'certificateCreate',
        updateUrl:'certificateUpdate',
        deleteUrl:'certificateDelete',
        loading:true,
        items: [],
        errors:[],
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    }
}
  
const productReducer = (state = initialState, action) => {

    const { infoType } = action
    
    switch (action.type) {
        case 'ADD_PRODUCT_ROUTE_INFO':
            
            return {
                ...state,
                [infoType] : {
                    ...state[infoType],
                    adding:{
                        loading:true, 
                        isDone:false,
                        errors:[] 
                    }
                }
            }
        
        case 'ADD_PRODUCT_ROUTE_INFO_SUCCESS':
            return {
                ...state,
                [infoType] : {
                    ...state[infoType],
                    adding:{
                        loading:false, 
                        isDone:true,
                        errors:[] 
                    }
                }
            }

        case 'ADD_PRODUCT_ROUTE_INFO_FAIL':
            return {
                ...state,
                [infoType] : {
                    ...state[infoType],
                    adding:{
                        loading:false, 
                        isDone:false,
                        errors:action.errors  
                    }
                }
            }
        case 'UPDATE_PRODUCT_ROUTE_INFO':
            return {
                ...state,
                [infoType] : {
                    ...state[infoType],
                    updating:{
                        ...state[infoType].updating,
                        [action.id] : {
                            loading:true, 
                            isDone:false,
                            errors:[] 
                        }
                        
                    }
                }
            }
        
        case 'UPDATE_PRODUCT_ROUTE_INFO_SUCCESS':

            return {
                ...state,
                [infoType] : {
                    ...state[infoType],
                    updating:{
                        ...state[infoType].updating,
                        [action.id] : {
                            loading:false, 
                            isDone:true, 
                            errors:[]
                        }
                    }
                }
               
            }

        case 'UPDATE_PRODUCT_ROUTE_INFO_FAIL':
            return {
                ...state,
                [infoType] : {
                    ...state[infoType],
                    updating:{
                        ...state[infoType].updating,
                        [action.id] : {
                            loading:false, 
                            isDone:false, 
                            errors:action.errors
                        }
                    }
                }
                
            }
        case 'DELETE_PRODUCT_ROUTE_INFO':
            return {
                ...state,
                [infoType] : {
                    ...state[infoType],
                    deleting:{
                        ...state[infoType].deleting,
                        [action.id] : {
                            loading:true, 
                            errors:[] 
                        }
                    }
                }
            }
        
        case 'DELETE_PRODUCT_ROUTE_INFO_SUCCESS':

            return {
                ...state,
                [infoType] : {
                    ...state[infoType],
                    deleting:{
                        ...state[infoType].deleting,
                        [action.id] : {
                            loading:false, 
                        errors:[] 
                        }
                    }
                }
            }

        case 'DELETE_PRODUCT_ROUTE_INFO_FAIL':
            return {
                ...state,
                [infoType] : {
                    ...state[infoType],
                    deleting:{
                        ...state[infoType].deleting,
                        [action.id] : {
                            loading:false, 
                            errors:action.errors
                        }
                    }
                }
            }
        default:
        return state
    }
}
  
  export default productReducer
  